var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12046_12089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 18.7393 20.4287 23.9106 14.4531 24.8481V16.1133H17.3657L17.9199 12.5H14.4531V10.1553C14.4531 9.1665 14.9375 8.20312 16.4902 8.20312H18.0664V5.12695C18.0664 5.12695 16.6357 4.88281 15.2681 4.88281C12.4131 4.88281 10.5469 6.61328 10.5469 9.74609V12.5H7.37305V16.1133H10.5469V24.8481C4.57129 23.9106 0 18.7393 0 12.5C0 5.59668 5.59668 0 12.5 0C19.4033 0 25 5.59668 25 12.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3657 16.1133L17.9199 12.5H14.4531V10.1552C14.4531 9.1667 14.9374 8.20312 16.4902 8.20312H18.0664V5.12695C18.0664 5.12695 16.6359 4.88281 15.2683 4.88281C12.413 4.88281 10.5469 6.61328 10.5469 9.74609V12.5H7.37305V16.1133H10.5469V24.8481C11.1833 24.948 11.8355 25 12.5 25C13.1645 25 13.8167 24.948 14.4531 24.8481V16.1133H17.3657Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12046_12089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d7d502059b05dee13cb935ff6ab0c3db.svg";
export { ForwardRef as ReactComponent };